import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    dataDashboard: localStorage.getItem("Dashboard_parents") && JSON.parse(decodeURIComponent(escape(atob((localStorage.getItem("Dashboard_parents"))))))
}
export const index = createSlice({
    name: "dataDashboard",
    initialState,
    reducers: {
        addDashboardHandler: (state, action) => {
            state.dataDashboard = action.payload;
            localStorage.setItem("Dashboard_parents", btoa(unescape(encodeURIComponent(JSON.stringify(action.payload)))));
        }
    }
})

export const { addDashboardHandler } = index.actions

export default index.reducer